import { motion } from "framer-motion";
import { Gift, Check } from "lucide-react";
import { mediaUrl } from "@/api";

const StampSlot = ({ index, filled, isReward }) => (
  <div data-testid={`stamp-slot-${index}`}
    className={`h-11 rounded-xl flex items-center justify-center relative overflow-hidden transition-colors ${filled ? "" : isReward ? "border-2 border-dashed bg-slate-50" : "border border-slate-200/80 bg-slate-50"}`}
    style={filled
      ? { background: "color-mix(in srgb, var(--brand-primary) 12%, white)", boxShadow: "inset 0 0 0 2px color-mix(in srgb, var(--brand-primary) 30%, white)" }
      : isReward ? { borderColor: "var(--brand-secondary)" } : {}}>
    {filled ? (
      <motion.div initial={{ scale: 0.3, rotate: -20, opacity: 0 }} animate={{ scale: 1, rotate: 0, opacity: 1 }} transition={{ type: "spring", stiffness: 260, damping: 16 }}
        className="h-7 w-7 rounded-full flex items-center justify-center" style={{ background: "var(--brand-primary)" }}>
        {isReward ? <Gift className="h-4 w-4 text-white" /> : <Check className="h-4 w-4 text-white" strokeWidth={3} />}
      </motion.div>
    ) : isReward ? (
      <Gift className="h-5 w-5" style={{ color: "var(--brand-secondary)" }} />
    ) : (
      <span className="text-slate-400 font-display font-bold text-[15px]">{index}</span>
    )}
  </div>
);

export const StampCard = ({ stamps, total = 10, businessName = "Bonstelo", logoUrl }) => {
  const logo = mediaUrl(logoUrl);
  const slots = Array.from({ length: total }, (_, i) => i + 1);
  return (
    <div data-testid="stamp-card-container" className="bg-white rounded-[22px] ring-1 ring-slate-100 shadow-brand overflow-hidden">
      <div className="brand-wave card-sheen px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <div className="h-8 w-8 rounded-lg bg-white/15 backdrop-blur flex items-center justify-center overflow-hidden shrink-0">
            {logo ? <img src={logo} alt="" className="h-7 w-7 object-contain" /> : <span className="text-white font-display font-extrabold">{businessName[0]}</span>}
          </div>
          <div className="min-w-0">
            <p className="text-white/85 text-[10px] font-bold uppercase tracking-[0.18em]">Treuekarte</p>
            <p className="text-white font-display font-extrabold text-[15px] leading-tight truncate">{businessName}</p>
          </div>
        </div>
        <div className="bg-white/20 rounded-full px-3 py-1 backdrop-blur shrink-0">
          <span data-testid="stamp-count-badge" className="text-white font-display font-extrabold text-sm">{stamps}/{total}</span>
        </div>
      </div>
      <div className="p-3 grid grid-cols-5 gap-2">
        {slots.map((n) => <StampSlot key={n} index={n} filled={stamps >= n} isReward={n === total} />)}
      </div>
    </div>
  );
};
